import type {
  DataBindingFilterProperty,
  DataBindingProperty,
} from '@wix/data-binding-registry-sdk'
import type { DigestedSchemaField } from '@wix/wix-data-client-common-standalone'
import { FieldType } from '@wix/wix-data-schema-types'
const { pageLink } = FieldType

const errorTypes = {
  BOUND_TO_DELETED_FIELD: 'BOUND_TO_DELETED_FIELD',
  BOUND_TO_UNSUPPORTED_FIELD: 'BOUND_TO_UNSUPPORTED_FIELD',
}

const isValidFieldBinding = (
  field: { type: FieldType; isDeleted?: boolean } | undefined,
  propertyDef: DataBindingFilterProperty | DataBindingProperty,
) => {
  if (!field || field.isDeleted) {
    return false
  }
  const supportedFieldTypes = propertyDef?.supportedFieldTypes || []

  const supportsPageLinks =
    'supportPageLinks' in propertyDef && propertyDef.supportPageLinks

  const allSupportedFieldTypes = supportedFieldTypes.concat(
    supportsPageLinks ? pageLink : [],
  )

  return allSupportedFieldTypes.includes(field.type)
}

const getInvalidBindingErrorType = (
  fields: DigestedSchemaField[],
  fieldPath: string,
) => {
  const field = fields.find(({ name }) => name === fieldPath)

  return field && field.isDeleted
    ? errorTypes.BOUND_TO_DELETED_FIELD
    : errorTypes.BOUND_TO_UNSUPPORTED_FIELD
}

export { isValidFieldBinding, getInvalidBindingErrorType }
